import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import "../../wepcg/sidebar/css/wepcg_bar.css"
import Help_hints from "../../wepcg/sidebar/help_hints";

class InvoiceDisputeBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Invoice Dispute (Rebill)</strong></h1>
            <p>
                This claim type is used for invoice discrepancies requiring correction through credit or debit note. For example: incorrect billing address, purchase order reference on invoice, incorrect VAT charged etc. Please attach as much background information as possible in order to help us process the dispute fast.
            </p>
            <Help_hints />
        </div>
    }
}

export default InvoiceDisputeBar;